import {
    ANALYTICS_PRODUCT_TRACK,
    ANALYTICS_PRODUCT_TRACK_SUCCESS,
    ANALYTICS_PRODUCT_TRACK_FAILURE,
    ANALYTICS_PRODUCT_SEARCH,
    ANALYTICS_PRODUCT_SEARCH_SUCCESS,
    ANALYTICS_PRODUCT_SEARCH_FAILURE,
  } from "redux/constants/actionTypes";
  
  let initialState = {
    analyticsproductTrackLoading: true,
    analyticsproductTrackError: "",
    analyticsproductSearchLoading: true,
    analyticsproductSearchError: "",
  };
  
  const analyticsReducer = (state = initialState, action) => {
    /// Product tracking
    switch (action.type) {
      case ANALYTICS_PRODUCT_TRACK:
        return {
          ...state,
          analyticsproductTrackLoading: true,
        };
      case ANALYTICS_PRODUCT_TRACK_SUCCESS:
        return {
          ...state,
          analyticsproductTrackLoading: false
        };
      case ANALYTICS_PRODUCT_TRACK_FAILURE:
        return {
          ...state,
          analyticsproductTrackError: action.payload.error
        };
        
      case ANALYTICS_PRODUCT_SEARCH:
        return {
          ...state,
          analyticsproductSearchLoading: true,
        };
      case ANALYTICS_PRODUCT_SEARCH_SUCCESS:
        return {
          ...state,
          analyticsproductSearchLoading: false
        };
      case ANALYTICS_PRODUCT_SEARCH_FAILURE:
        return {
          ...state,
          analyticsproductSearchError: action.payload.error 
        };
  
      default:
        return state;
    }


  };
  
  export default analyticsReducer;